var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08906 9.58511C9.03656 9.57761 8.96906 9.57761 8.90906 9.58511C7.58906 9.54011 6.53906 8.46011 6.53906 7.13261C6.53906 5.77511 7.63406 4.67261 8.99906 4.67261C10.3566 4.67261 11.4591 5.77511 11.4591 7.13261C11.4516 8.46011 10.4091 9.54011 9.08906 9.58511Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0553 14.5349C12.7203 15.7574 10.9503 16.4999 9.00031 16.4999C7.05031 16.4999 5.28031 15.7574 3.94531 14.5349C4.02031 13.8299 4.47031 13.1399 5.27281 12.5999C7.32781 11.2349 10.6878 11.2349 12.7278 12.5999C13.5303 13.1399 13.9803 13.8299 14.0553 14.5349Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.4998C13.1421 16.4998 16.5 13.1419 16.5 8.99976C16.5 4.85762 13.1421 1.49976 9 1.49976C4.85786 1.49976 1.5 4.85762 1.5 8.99976C1.5 13.1419 4.85786 16.4998 9 16.4998Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.b41e31e48b9ccd0c66e9545dc5d8447f.svg";
export { ForwardRef as ReactComponent };